<script setup lang="ts">
import { SbListItem, SbListLabel, SbListSection } from "@unio/saltbox-ui"

import { pluralize } from "@/lib/format"
import { ICON } from "@/lib/icons"
import { personPath } from "@/routes"
import type { PersonSummary } from "@/types/models"

defineProps<{ person: PersonSummary }>()
</script>

<template>
  <SbListItem :to="personPath({ id: person.id })">
    <SbListSection avatar>
      <UIcon :name="ICON.people" class="text-muted size-5" />
    </SbListSection>
    <SbListSection>
      <SbListLabel>{{ person.name }}</SbListLabel>
      <SbListLabel v-if="person.relationship" caption>{{ person.relationship }}</SbListLabel>
    </SbListSection>
    <SbListSection side>
      <div class="flex items-center gap-2">
        <span v-if="person.items_count" class="text-muted text-xs">
          {{ pluralize(person.items_count, "item") }}
        </span>
        <UIcon :name="ICON.chevronRight" class="size-4" />
      </div>
    </SbListSection>
  </SbListItem>
</template>
